import React, { useEffect } from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import InfoMessage from "components/ui/controls/info-message/info-message";
import Switch from "components/ui/controls/switch/Switch";

const InvaliditeRetraite = (props) => {
  const { ClientConjoint } = props;
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  useEffect(() => {
    ResultatTNS.GetResultBilanRetraite(context.state, "").then((ResultatRetraite) => {});
    if (context.state.InclureConjoint === true) {
      ResultatTNS.GetResultBilanRetraite(context.state, "Conjoint").then((ResultatRetraite) => {});
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const Regime = ({ nom, regime, ClientConjoint }) => {
    return (
      <div className="card">
        <div className="category-column">
          <div className="titre-icone">📋</div>
          {nom}
        </div>
        <div className="value-column">
          <Switch checked={context.state[regime + ClientConjoint]} onChange={(checked) => context.handleValueChange(regime + ClientConjoint, checked)} label="" color="primary" size="sm" />
        </div>
      </div>
    );
  };

  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            <Row >
              <InfoMessage
                text={
                  <>
                    Cet onglet vous permet de cocher les régimes pour lesquels vous souhaitez forcer le taux plein. Cela permet notamment de prévoir les cas de départ pour invalidité ou
                    inaptitude. Attention, le logiciel ne vérifie pas si les régimes listés ci dessous prévoient cette possibilité ou si les conditions relatives à ces dispositifs sont
                    remplies. Il vous appartient donc de vérifier ces points et MAKO ne peut être tenu responsable d'une éventuelle erreur. Avant toute prise de décision, nous vous invitons
                    à contacter la caisse concernée.
                  </>
                }
              />
            </Row>
            <Row tpad>
              <Column fill>
                <div className="header-card">
                  <div className="category-column">
                    <span className="header-icon">💼</span>
                    Régimes de base
                  </div>
                  <div className="value-column">
                    <span className="header-icon">🔓</span>
                    Forcer le taux plein
                  </div>
                </div>
                <div className="card-list-container">
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("RegimeUnifie") && (
                    <Regime nom="Régime unifié" regime="InvaliditeRegimeUnifie" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Cnavpl") && (
                    <Regime nom="CNAVPL" regime="InvaliditeCnavpl" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("FonctionPubliqueBase") && (
                    <Regime nom="Fonction publique" regime="InvaliditeFonctionPubliqueBase" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Crpcen") && (
                    <Regime nom="CRPCEN" regime="InvaliditeCrpcen" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Cnbf") && (
                    <Regime nom="CNBF" regime="InvaliditeCnbf" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Msa") && (
                    <Regime nom="MSA" regime="InvaliditeMsa" ClientConjoint={ClientConjoint} />
                  )}
                </div>
              </Column>
            </Row>
            <Row>
              <Column fill>
                <div className="header-card">
                  <div className="category-column">
                    <span className="header-icon">💼</span>
                    Régimes complémentaires
                  </div>
                  <div className="value-column">
                    <span className="header-icon">🔓</span>
                    Forcer le taux plein
                  </div>
                </div>
                <div className="card-list-container">
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Salarie") && (
                    <Regime nom="AGIRC-ARRCO" regime="InvaliditeAgircArrco" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Ircantec") && (
                    <Regime nom="IRCANTEC" regime="InvaliditeIrcantec" ClientConjoint={ClientConjoint} />
                  )}
                  {(ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("RsiArtisan") ||
                    ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("RsiCommercant") ||
                    ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("RCI")) && (
                    <Regime nom="RCI" regime="InvaliditeRCI" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Ravgdt") && (
                    <Regime nom="RAVGDT" regime="InvaliditeRavgdt" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Cipav") && (
                    <Regime nom="CIPAV" regime="InvaliditeCipav" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Cavec") && (
                    <Regime nom="CAVEC" regime="InvaliditeCavec" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Cnbf") && (
                    <Regime nom="CNBF" regime="InvaliditeCnbfComp" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Cavom") && (
                    <Regime nom="CAVOM" regime="InvaliditeCavom" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Crn") && (
                    <Regime nom="CRN" regime="InvaliditeCrn" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Cavamac") && (
                    <Regime nom="CAVAMAC" regime="InvaliditeCavamac" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Carpv") && (
                    <Regime nom="CARPV" regime="InvaliditeCarpv" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Carpimko") && (
                    <Regime nom="CARPIMKO" regime="InvaliditeCarpimko" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Carcdsf") && (
                    <Regime nom="CARCD" regime="InvaliditeCarcdsf" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Carcdsf2") && (
                    <Regime nom="CARSF" regime="InvaliditeCarcdsf2" ClientConjoint={ClientConjoint} />
                  )}
                  {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Cavp") && (
                    <Regime nom="CAVP" regime="InvaliditeCavp" ClientConjoint={ClientConjoint} />
                  )}
                </div>
              </Column>
            </Row>
            {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.TotalPensionSupplementaire > 0 && (
              <Row tpad>
                <Column fill>
                  <div className="header-card">
                    <div className="category-column">
                      <span className="header-icon">💼</span>
                      Régimes supplémentaires
                    </div>
                    <div className="value-column">
                      <span className="header-icon">🔓</span>
                      Forcer le taux plein
                    </div>
                  </div>
                  <div className="card-list-container">
                    {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Carcdsf") &&
                      (ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Carcdsf"]["General"]["AsvTotalPointAvant1995"] > 0 ||
                        ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Carcdsf"]["General"]["AsvTotalPoint19952005"] > 0 ||
                        ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Carcdsf"]["General"]["AsvTotalPointApres2006"] > 0) && (
                        <Regime nom="CARCD ASV" regime="InvaliditeCarcdsfAsv" ClientConjoint={ClientConjoint} />
                      )}
                    {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Carcdsf2") &&
                      (ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Carcdsf2"]["General"]["AsvTotalPointAvant1995"] > 0 ||
                        ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Carcdsf2"]["General"]["AsvTotalPoint19952005"] > 0 ||
                        ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Carcdsf2"]["General"]["AsvTotalPointApres2006"] > 0) && (
                        <Regime nom="CARSF ASV" regime="InvaliditeCarcdsf2Asv" ClientConjoint={ClientConjoint} />
                      )}
                    {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Carmf") &&
                      ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Carmf"]["General"]["TotalPointAsv"] > 0 && (
                        <Regime nom="CARMF ASV" regime="InvaliditeCarmfAsv" ClientConjoint={ClientConjoint} />
                      )}
                    {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Carpimko") &&
                      (ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Carpimko"]["General"]["AsvTotalPoint19761987"] > 0 ||
                        ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Carpimko"]["General"]["AsvTotalPoint19881997"] > 0 ||
                        ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Carpimko"]["General"]["AsvTotalPoint19982005"] > 0 ||
                        ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Carpimko"]["General"]["AsvTotalPointApres2005"] > 0) && (
                        <Regime nom="CARPIMKO ASV" regime="InvaliditeCapimkoAsv" ClientConjoint={ClientConjoint} />
                      )}
                    {ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite?.hasOwnProperty("Cavp") &&
                      (ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint19821986"] > 0 ||
                        ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint19871991"] > 0 ||
                        ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint19921996"] > 0 ||
                        ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint19972001"] > 0 ||
                        ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Cavp"]["General"]["AsvTotalPoint20022005"] > 0 ||
                        ResultatTNS.state["Retraite" + ClientConjoint].InfosRetraiteChoixDepart?.InfosRetraite["Cavp"]["General"]["AsvTotalPointAPartir2024"] > 0) && (
                        <Regime nom="CAVP ASV" regime="InvaliditeCavpAsv" ClientConjoint={ClientConjoint} />
                      )}
                  </div>
                </Column>
              </Row>
            )}
          </Column>
        </CardBox>
      </Column>
    </>
  );
};
export default InvaliditeRetraite;
